// extracted by mini-css-extract-plugin
module.exports = {"load-more-button__button":"load-more-button__button__yGCWc","active":"active__zhh9Y"};